// src/components/Dashboard.js
import React, { useState } from 'react';
import { Box, Toolbar, AppBar, IconButton, Typography, Drawer, List, ListItem, ListItemText } from '@mui/material';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Courses from './pages/Courses';
import Grades from './pages/Grades';
import VirtualIDCard from './pages/VirtualIDCard';
import { CircularProgress } from "@mui/material"; // Import CircularProgress
import MCQQuizWithCertificate from './pages/MCQQuizWithCertificate';
import MockTest from './pages/MockTest';
import Navbar from './Navbar';
import StudentAttendance from '../../componests/studentDashboard/pages/StudentAttendance';
import {url,localUrl} from './../../BaseUrl'
import { useQuery } from "react-query";
import axios from "axios";
const drawerWidth = 240;
const Dashboard = () => {
  const [activeSection, setActiveSection] = useState('home');
  const { isLoading, error, data } = useQuery("fetchAllStudents", async () => {
    const token = sessionStorage.getItem("studentToken");

    const response = await axios.get(
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in the Authorization header
          "Content-Type": "application/json",
        },
      }
      
    );
   
    return response.data; // Return the fetched data
  });


  const renderSection = () => {
    switch (activeSection) {
      case 'home':
        return <Home data={data}/>;
      case 'profile':
        return <Profile data={data}/>;
      case 'courses':
        return <Courses data={data}/>;
      case 'grades':
        return <Grades data={data}/>;
      case 'virtualIDCard':
        return <VirtualIDCard data={data}/>;
    case 'mockTest':
    return <MockTest/>;
    case 'attendence':
      return <StudentAttendance />;
      default:
        return <Home />;
    }
  };
 // Display loading state
 if (isLoading) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh", // Full height to center the loader
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        Loading...
      </Typography>
    </Box>
  );
}

// Display error message if there's an error
if (error) {
  return (
    <Typography variant="h6">
      An error has occurred: {error.message}
    </Typography>
  );
}
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
       <Navbar/>
      </AppBar>

      {/* Permanent Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' }
        }}
      >
        <Toolbar />
        <List>
          <ListItem button onClick={() => setActiveSection('home')}>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button onClick={() => setActiveSection('profile')}>
            <ListItemText primary="Profile" />
          </ListItem>
          <ListItem button onClick={() => setActiveSection('courses')}>
            <ListItemText primary="Courses" />
          </ListItem>
          <ListItem button onClick={() => setActiveSection('grades')}>
            <ListItemText primary="Grades" />
          </ListItem>
          <ListItem button onClick={() => setActiveSection('virtualIDCard')}>          
          <ListItemText primary="Virtual ID Card" />
            </ListItem>
            <ListItem button onClick={() => setActiveSection('mockTest')}>          
          <ListItemText primary="MockTest" />
            </ListItem>
            <ListItem button onClick={() => setActiveSection('attendence')}>          
          <ListItemText primary="attendence" />
            </ListItem>
        </List>
      </Drawer>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          
        }}
      >
        <Toolbar />
        {renderSection()}
      </Box>
    </Box>
  );
}
export default Dashboard;
